import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import {
  useIsAuthenticated,
  useIsEmailVerified,
  useIsUsernameVerified,
} from "../user/token";
import {
  MODAL_QUERY_PARAM_KEY,
  AUTH_INTERRUPT_MODAL_QUERY_PARAM,
  VERIFY_EMAIL_MODAL_QUERY_PARAM,
  CREATE_USERNAME_MODAL_QUERY_PARAM,
} from "./constants";

export const useModal = (modalId) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const openModal = useCallback(() => {
    searchParams.append(MODAL_QUERY_PARAM_KEY, modalId);
    setSearchParams(searchParams, { preventScrollReset: true });
  }, [searchParams, modalId]);

  const closeModal = useCallback(() => {
    setSearchParams(searchParams.delete(MODAL_QUERY_PARAM_KEY), {
      preventScrollReset: true,
    });
  }, [searchParams]);

  return {
    isOpen: searchParams.get(MODAL_QUERY_PARAM_KEY) === modalId,
    openModal,
    closeModal,
  };
};

export const useRestrictionModal = () => {
  const isAuthenticated = useIsAuthenticated();
  const isEmailVerified = useIsEmailVerified();
  const isUsernameVerified = useIsUsernameVerified();
  const { openModal: showAuthInterruptModal } = useModal(
    AUTH_INTERRUPT_MODAL_QUERY_PARAM
  );
  const { openModal: showEmailVerificationModal } = useModal(
    VERIFY_EMAIL_MODAL_QUERY_PARAM
  );
  const { openModal: showUsernameVerificationModal } = useModal(
    CREATE_USERNAME_MODAL_QUERY_PARAM
  );
  const wrapHandler = useCallback(
    (fn) =>
      (...args) => {
        switch (false) {
          case isAuthenticated:
            showAuthInterruptModal();
            break;
          case isEmailVerified:
            showEmailVerificationModal();
            break;
          case isUsernameVerified:
            showUsernameVerificationModal();
            break;
          default:
            fn(...args);
        }
      },
    [
      isAuthenticated,
      isEmailVerified,
      isUsernameVerified,
      showAuthInterruptModal,
      showEmailVerificationModal,
      showUsernameVerificationModal,
    ]
  );

  return { wrapHandler };
};
